import { useState } from "preact/hooks";

interface FloatingLabelInputProps {
  id: string;
  label: string;
  value: string;
  onValueChange: (value: string) => void;
  error?: string;
  borderRadius?: number;
  fontFamily?: string;
  fontSize?: number;
  labelBgColor?: string;
  borderDefaultColor?: string;
  borderFocusColor?: string;
  labelIdleColor?: string;
  labelActiveColor?: string;
  inputTextColor?: string;
  errorColor?: string;
}

export default function FloatingLabelInput({
  id,
  label,
  value,
  onValueChange,
  error,
  borderRadius = 8,
  fontFamily,
  fontSize = 16,
  labelBgColor = "#ffffff",
  borderDefaultColor = "#8a8a8a",
  borderFocusColor = "#1a1a1a",
  labelIdleColor = "#616161",
  labelActiveColor = "#1a1a1a",
  inputTextColor = "#1a1a1a",
  errorColor = "#e51c00",
}: FloatingLabelInputProps) {
  const [focused, setFocused] = useState(false);
  const floated = focused || value.length > 0;

  const controlClass = [
    "floating-field__control",
    floated ? "is-floated" : "",
    focused ? "is-focused" : "",
    error ? "is-error" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className="floating-field"
      style={
        {
          fontFamily,
          "--floating-field-label-bg": labelBgColor,
          "--floating-field-border-default": borderDefaultColor,
          "--floating-field-border-focus": borderFocusColor,
          "--floating-field-label-idle": labelIdleColor,
          "--floating-field-label-active": labelActiveColor,
          "--floating-field-input-text": inputTextColor,
          "--floating-field-error-color": errorColor,
          "--floating-field-border-radius": borderRadius + "px",
        } as Record<string, string>
      }
    >
      <div className={controlClass} style={{ borderRadius }}>
        <label
          htmlFor={id}
          className="floating-field__label"
          style={{ fontSize: floated ? 13 : fontSize }}
        >
          {label}
        </label>
        <input
          id={id}
          className="floating-field__input"
          type="text"
          value={value}
          style={{ fontSize, fontFamily }}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onInput={(e) => onValueChange((e.target as HTMLInputElement).value)}
        />
      </div>
      {error && (
        <p className="floating-field__error" style={{ color: errorColor }}>
          {error}
        </p>
      )}
    </div>
  );
}
